import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TypeButtonData } from "../../ui-dto/button/type-button-data";
var HTML_TEMPLATE = "\n<button  class=\"od-button\" \n\t[type]=\"buttonType\"\n\t[ngStyle]=\"type === '" + TypeButtonData.SPLIT_BUTTON + "' && {'background-color':bgColor,'color':color,'width': 'calc(' + size + ' - 38px)'} || {'background-color':bgColor,'color':color,'width': size}\" \n\t[ngClass]=\"{'od-button-as-dropdown': type ===  '" + TypeButtonData.DROPDOWN + "',\n\t'od-button-as-split-button': type ===  '" + TypeButtonData.SPLIT_BUTTON + "'}\"\n\t[attr.disabled]=\"disabled == true ? true : null\"\n\t[attr.active]=\"active == true ? true : null\">\n\t\t<div *ngIf=\"iconName !=null\" [class]=\"iconName +' od-button-icon'\" [ngStyle]=\"file === true && {'background-image':'url('+ iconName + ')', 'width': '20px', 'height': '20px','background-size': 'contain',\n    'background-position' : 'center', 'padding-right': '25px','background-repeat': 'no-repeat','opacity':'1'}\" ></div>\n\t\t<ng-content></ng-content>\n\t\t<div class=\"od-button-inner\" [textContent]=\"_text\"></div>\n\t\t<div *ngIf=\"type === '" + TypeButtonData.DROPDOWN + "'\"\n\t\t(click)=\"onClickDropdown()\" class=\"odi_dropdown od-button-dropdown\"></div>\n</button>\n<div *ngIf=\"type ===  '" + TypeButtonData.SPLIT_BUTTON + "'\" (click)=\"onClickDropdown()\" \nclass=\"odi_dropdown od-button-split-button\" [ngStyle]=\"{'background-color':bgColor,'color':color}\"></div>\n";
var CSS_STYLE = "\n.od-button,\n.od-button-split-button{\n\tdisplay: flex;\n\tjustify-content: center;\n\tcursor: pointer;\n\tborder: none;\n\toutline-width: 0;\n\tflex-shrink: 0;\n\tflex-grow: 0;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\tfont-size: 14px;\n\talign-items: center;\n\theight: 38px;\n}\n\n.od-button{\n\tborder-radius: 4px;\n}\n\n.od-button-split-button{\n\twidth: 38px;\n}\n\n.od-button.od-button-as-split-button{\n\tfloat:left;\n}\n\n.od-button-as-dropdown,\n.od-button-as-split-button{\n\tborder-radius:0;\n}\n\n.od-button-icon{\n    padding-right: 8px;\n    font-size: 16px;\n    opacity: .5;\n\twidth:34px;\n}\n\n.od-button,\n.od-button-inner {\n    font-weight: bold;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: auto;\n}\n\n.od-button-as-dropdown > .od-button-dropdown{\n\twidth:25px;\n}\n\n.od-button-as-dropdown > .od-button-inner{\n\tflex-grow:1;\n}\n.od-button-as-dropdown > .od-button-dropdown{\n\tfont-size: 11px;\n\tfont-weight: normal;\n    color: #edeef1;\n}\n.od-button:hover,\n.od-button-split-button:hover{\n\tfilter:saturate(80%) brightness(108%);\n}\n.od-button:disabled {\n\tfilter: grayscale(200%) saturate(64%) brightness(123%);\n    background-color: #9b9fa8;\n    cursor: default;\n    opacity:1;\n}\n.od-button[active] {\n    filter: saturate(150%) brightness(80%);\n}\n\n@media screen and (max-width: 400px){\n\t.od-button-inner{\n\t\tmax-width:200px;\n\t}\n\t.od-button{\n\t\tmax-width: 130px;\n    \tmin-width: 88px;\n\t}\n}\n";
var Button = /** @class */ (function () {
    function Button() {
        this.dropdownClick = new EventEmitter();
        this.text = "";
        this.disabled = false;
        this.active = false;
        this.size = "180px";
        this.bgColor = "#25aed8";
        this.color = "#FFFFFF";
    }
    Object.defineProperty(Button.prototype, "text", {
        set: function (value) {
            if (value != null)
                this._text = value;
        },
        enumerable: true,
        configurable: true
    });
    Button.prototype.onClickDropdown = function () {
        if (this.dropdownClick != null)
            this.dropdownClick.emit();
    };
    Button.decorators = [
        { type: Component, args: [{
                    selector: "od-button",
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    Button.ctorParameters = function () { return []; };
    Button.propDecorators = {
        "disabled": [{ type: Input },],
        "active": [{ type: Input },],
        "type": [{ type: Input },],
        "size": [{ type: Input },],
        "iconName": [{ type: Input },],
        "file": [{ type: Input },],
        "bgColor": [{ type: Input },],
        "color": [{ type: Input },],
        "buttonType": [{ type: Input },],
        "dropdownClick": [{ type: Output },],
        "text": [{ type: Input },],
    };
    return Button;
}());
export { Button };
//# sourceMappingURL=button.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/button/button.js
// module id = 410
// module chunks = 14